import { API } from "aws-amplify";
import { getTransaction } from "~/graphql/queries";
import * as APITypes from "~/API";

export const EMPTY_TRANSACTION: APITypes.Transaction = {
  __typename: "Transaction",
  id: "",
  amount: 0,
  dateSent: "",
  dateReceived: "",
  reason: APITypes.TransactionReason.OtherPayment,
  currency: "",
  tenantID: "",
  managerID: "",
  paymentMethod: APITypes.RentPaymentMethodType.Check,
  createdAt: "",
  updatedAt: "",
  status: APITypes.PaymentStatusType.Pending,
  entityID: "",
  entityType: "",
  month: 0,
  year: 0,
  _version: 0,
  _lastChangedAt: 0,
};

export const getTransactionInfo = async (transactionID: string) => {
  try {
    const response = (await API.graphql({
      query: getTransaction,
      variables: {
        id: transactionID,
      },
    })) as { data?: APITypes.GetTransactionQuery };

    return {
      success: true,
      data: response.data?.getTransaction || EMPTY_TRANSACTION,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_TRANSACTION,
      error,
    };
  }
};
